import { useNodesData, Handle, Position, useUpdateNodeInternals } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
  NodePorts,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { DelayMode, TDelayNodeConfig } from "../Models/Delay";
import { useEffect, useMemo } from "react";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import useNodeExecution from "./Hooks/useNodeExecution";
import usePipelineNode from "./Hooks/usePipelineNode";

export default DelayNode;

function DelayNode(props) {
  const { id } = props;
  const updateNodeInternals = useUpdateNodeInternals();

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TDelayNodeConfig>(id);

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.DELAY]["default"];

  const ports =
    data.delayMode === DelayMode.UNTIL_TIMESTAMP && data.skipIfPast
      ? ["default", "skipped"]
      : ["default"];

  useEffect(() => {
    setTimeout(() => {
      updateNodeInternals(id);
    }, 0);
  }, [ports.join(","), updateNodeInternals]);

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {!isPreviewMode && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}
            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
      <NodePorts ports={ports} />
    </>
  );
}
